// import ContactSection from "../../components/ContactForm";
// import Header from "../../components/Header";

// import { motion } from 'framer-motion';
// import { Printer, FileCheck, Palette, CheckCircle, ArrowRight, Award, Clock, Shield } from 'lucide-react';

// import HeroSection from "../../components/HeroSection";
// import ServicesSection from "../../components/Services";
// import StepSection from "../../components/ServicesSection";
// import bannerImg from "../../assets/Firefly 20250214075131.png";

// export default function OffsetPrinting() {
//   const fadeIn = {
//     initial: { opacity: 0, y: 20 },
//     animate: { opacity: 1, y: 0 },
//     transition: { duration: 0.6 }
//   };

//   const steps = [
//     {
//       icon: <FileCheck className="w-12 h-12 text-primary-base" />,
//       title: "Prepress Preparation",
//       description: "Our offset printing process starts with meticulous prepress work, ensuring all your designs are formatted perfectly for print."
//     },
//     {
//       icon: <Palette className="w-12 h-12 text-primary-base" />,
//       title: "Color Consistency",
//       description: "With offset printing, we ensure that color accuracy and consistency are maintained across all your prints, regardless of batch size."
//     },
//     {
//       icon: <CheckCircle className="w-12 h-12 text-primary-base" />,
//       title: "Large Volume Capability",
//       description: "Offset printing is ideal for large volume jobs. We deliver exceptional quality and efficiency for large runs with minimal cost."
//     }
//   ];

//   const benefits = [
//     {
//       icon: <Award className="w-8 h-8" />,
//       title: "Superior Print Quality",
//       description: "Offset printing produces sharp, clean, and high-quality prints that remain consistent throughout large runs."
//     },
//     {
//       icon: <Clock className="w-8 h-8" />,
//       title: "Cost-Effective for Large Volumes",
//       description: "Offset printing is highly cost-effective for large print runs, making it the ideal choice for bulk printing projects."
//     },
//     {
//       icon: <Shield className="w-8 h-8" />,
//       title: "Long-Lasting Prints",
//       description: "Offset printing creates durable prints that stand the test of time, with colors that won’t fade easily."
//     }
//   ];

//   return (
//     <div className="font-body">
//       <Header />

//       {/* Hero Section */}
//       <section className="relative overflow-hidden bg-gradient-to-br from-primary-dark to-primary-base py-20 lg:py-32">
//         <div className="absolute inset-0 bg-grid-white/[0.2] bg-[size:16px]" />
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div 
//             className="text-center"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <h1 className="text-5xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
//               <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
//                 Offset Printing Excellence
//               </span>
//             </h1>
//             <p className="text-xl text-neutral-200 max-w-2xl mx-auto mb-8">
//               Create high-quality prints in large volumes with precision and consistency. Our offset printing process delivers the best results for your projects.
//             </p>
//             <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
//               Get Started Today
//             </button>
//           </motion.div>
//         </div>
//       </section>

//       {/* What is Offset Printing Section */}
//       <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div 
//             className="text-center mb-15"
//             {...fadeIn}
//           >
//             <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base mb-4">
//               What is Offset Printing?
//             </h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Offset printing is a high-quality and cost-effective printing method that delivers sharp, vibrant prints with precision. It's ideal for large-volume runs with exceptional consistency.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Process Steps */}
//       <section className="py-20 bg-neutral-light">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
//             Our Offset Printing Process
//           </h2>
//           <div className="grid md:grid-cols-3 gap-8">
//             {steps.map((step, index) => (
//               <motion.div 
//                 key={index}
//                 className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.2 }}
//               >
//                 <div className="mb-6">{step.icon}</div>
//                 <h3 className="text-2xl font-bold text-primary-base mb-4">{step.title}</h3>
//                 <p className="text-gray-600">{step.description}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Image Section */}
//       <section className="">
//         <div className="text-center">
//           <div className="relative">
//             <img
//               src={bannerImg} // Replace with your image path
//               alt="Offset printing example"
//               className="w-full h-auto "
//             />
//           </div>
//         </div>
//       </section>

//       {/* Benefits Section */}
//       <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
//             Why Choose Our Offset Printing Services?
//           </h2>
//           <div className="grid md:grid-cols-3 gap-8">
//             {benefits.map((benefit, index) => (
//               <motion.div 
//                 key={index}
//                 className="p-6 rounded-xl bg-neutral-50 hover:bg-neutral-100 transition-colors duration-300"
//                 initial={{ opacity: 0, x: -20 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ delay: index * 0.2 }}
//               >
//                 <div className="flex items-center mb-4 text-primary-base">
//                   {benefit.icon}
//                   <h3 className="text-xl font-bold ml-3">{benefit.title}</h3>
//                 </div>
//                 <p className="text-gray-600">{benefit.description}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-20 bg-gradient-to-br from-primary-dark to-primary-base text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <h2 className="text-3xl md:text-5xl font-heading font-bold text-white text-4xl font-bold mb-8">Ready to Get Started?</h2>
//           <p className="text-xl mb-8 max-w-2xl mx-auto">
//             Let’s bring your offset print projects to life with the highest quality and most efficient service.
//           </p>
//           <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 flex items-center mx-auto">
//             Contact Us Today
//             <ArrowRight className="ml-2 w-5 h-5" />
//           </button>
//         </div>
//       </section>

//       <ServicesSection />

//       {/* Contact Section */}
//       <ContactSection />
//     </div>
//   );
// }

import ContactSection from "../../components/ContactForm";
import Header from "../../components/Header";

import { motion } from 'framer-motion';
import { Printer, FileCheck, Palette, CheckCircle, ArrowRight, Award, Clock, Shield } from 'lucide-react';

import HeroSection from "../../components/HeroSection";
import ServicesSection from "../../components/Services";
import StepSection from "../../components/ServicesSection";
import bannerImg from "../../assets/Firefly 20250214075131.png";
import { Link, useLocation } from "react-router-dom";
import Footer from "../../components/Footer";
import { useEffect } from "react";

export default function OffsetPrinting() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const steps = [
    {
      icon: <FileCheck className="w-12 h-12 text-primary-base" />,
      title: "File Setup",
      description: "We ensure that your digital files are correctly prepared for printing, checking resolution, file type, and layout."
    },
    {
      icon: <Palette className="w-12 h-12 text-primary-base" />,
      title: "Color Precision",
      description: "Our offset printing process ensures vibrant and consistent colors across all your print materials, using advanced color management techniques."
    },
    {
      icon: <CheckCircle className="w-12 h-12 text-primary-base" />,
      title: "Proofing",
      description: "We provide accurate proofing before final printing to ensure everything looks exactly how you want it."
    }
  ];

  const benefits = [
    {
      icon: <Award className="w-8 h-8" />,
      title: "High-Quality Prints",
      description: "We deliver sharp, vibrant, and detailed prints with every project, ensuring exceptional results."
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Fast Turnaround",
      description: "Get your prints quickly without compromising on quality, perfect for meeting tight deadlines."
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Eco-Friendly Printing",
      description: "We use eco-friendly inks and materials, minimizing waste while ensuring high-quality results."
    }
  ];

  return (
    <div className="font-body">
      <Header />

      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-primary-dark to-primary-base py-20 lg:py-32">
        <div className="absolute inset-0 bg-grid-white/[0.2] bg-[size:16px]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
                Offset Printing Excellence
              </span>
            </h1>
            <p className="text-xl text-neutral-200 max-w-2xl mx-auto mb-8">
              Experience top-quality, reliable, and cost-effective offset printing services with Capital Offset. Let us bring your designs to life!
            </p>
            <Link to="contact">
            <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
              Get Started Today
            </button>
            </Link>
          </motion.div>
        </div>
      </section>

      {/* What is Offset Printing Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center mb-15"
            {...fadeIn}
          >
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base mb-4">
              What is Offset Printing?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Offset printing, also known as lithographic printing, is a cost-effective and reliable method for high-quality print materials. Whether you’re printing marketing brochures, posters, or magazines, this technique guarantees consistent and vibrant results.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Process Steps */}
      <section className="py-20 bg-neutral-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
            Our Offset Printing Process
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <motion.div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <div className="mb-6">{step.icon}</div>
                <h3 className="text-2xl font-bold text-primary-base mb-4">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

 

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
            Why Choose Capital Offset for Your Printing Needs?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div 
                key={index}
                className="p-6 rounded-xl bg-neutral-50 hover:bg-neutral-100 transition-colors duration-300"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <div className="flex items-center mb-4 text-primary-base">
                  {benefit.icon}
                  <h3 className="text-xl font-bold ml-3">{benefit.title}</h3>
                </div>
                <p className="text-gray-600">{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-primary-dark to-primary-base text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white text-4xl font-bold mb-8">Ready to Get Started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Bring your projects to life with high-quality offset printing services at Capital Offset. Contact us today for a fast and reliable printing experience.
          </p>
          <Link to="contact">
          <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 flex items-center mx-auto">
            Contact Us Today
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
          </Link>
        </div>
      </section>

      <ServicesSection />

      {/* Contact Section */}
      <ContactSection />
      <Footer />
    </div>
  );
}

